import {Component, OnInit} from '@angular/core';
import {BaseListComponent} from "../base-list/base-list.component";
import {NgIf} from "@angular/common";
import {TemplateComponent} from "../template/template.component";
import {ActivatedRoute, Router} from "@angular/router";
import {CrudService} from "../service/crud.service";
import {BaseEditComponent} from "../base-edit/base-edit.component";
import {EInputType, IEditConfig} from "../../../interface/table.config";
import {ICrudRes} from "../../../interface/http.config";
import {Validators} from "@angular/forms";

@Component({
  selector: 'app-setting-edit',
  standalone: true,
  imports: [
    BaseListComponent,
    NgIf,
    TemplateComponent,
    BaseEditComponent
  ],
  templateUrl: './setting-edit.component.html',
  styleUrl: './setting-edit.component.scss'
})
export class SettingEditComponent implements OnInit {
  data: ICrudRes;
  id: string | null = null;

  constructor(protected router: Router,
              protected route: ActivatedRoute,
              protected crudService: CrudService) {

  }

  editLink = '/dashboard/setting-edit/';
  menuLink = '/dashboard/setting';
  ngOnInit() {
    this.id = this.route.snapshot.paramMap.get('id') || null;

    this.crudService.provider = 'setting';

    if (this.editConfig.groups.length && this.id) {

      this.editConfig.groups[0].configs = [
        {
          field: 'id',
          type: EInputType.DISABLED,
          name: 'Id',
          validators: [],
        },
        ...this.editConfig.groups[0].configs
      ];

      this.getItem();
    } else {
      this.data = {} as any;
    }
  }

  isTextArea() {
    const item = this.data as any;

    return item.key === 'NATIONALITY' || item.key === 'DOC_TYPE';
  }

  editConfig: IEditConfig = {
    groups: [
      {
        name: 'General (New Setting)',
        configs: [
          {field: 'key', name: 'Key', type: EInputType.TEXT, validators: [Validators.required]},
          {field: 'value', name: 'Value', type: EInputType.TEXT, validators: [Validators.required]},
        ]
      }
    ]
  };

  getItem() {
    this.crudService.item({id: this.id}).then(item => {
      this.data = item;

      if (this.isTextArea()) {
        this.editConfig.groups[0].configs[this.editConfig.groups[0].configs.length - 1].type = EInputType.TEXTAREA;
      }

      this.editConfig.groups[0].name = 'General (Setting ' + item.key + ')';
    }).catch(console.error);
  }

  onAction(actionName: string, item: any) {
    if (actionName === 'submit') {
      this.crudService.save(item).then((data) => {
        if (!item.id) {
          this.router.navigate([this.editLink + '/' + data.document.id]).catch(console.error);
        } else {
          this.getItem();
        }
      });
    }

    if (actionName === 'back') {
      this.router.navigate([this.menuLink]).catch(console.error);
    }
  }
}
